import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtilities } from 'src/app/core/utilities/number.utilities';

@Pipe({name: 'yesNoFormatter'})
export class YesNoFormatterPipe implements PipeTransform {
  transform(value: any): string {
    return value ? 'Yes' : 'No';
  }
}
